export * from './scrollTo.module';
export * from './scrollTo.service';
export * from './scrollTo.directive';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/tslint-loader?emitErrors=true&failOnHint=true!./src/index.ts